import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NitroNavBar, NitroPanel, NitroLoading } from 'nitro-components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import 'powerbi-client';

import Breakpoint from '../../utils/breakpoints';
import { pushGAAction } from '../../utils/gtm';

import PowerBIApi from '../../api/PowerBIApi';

import SectionHeader, {
  LeftSection,
  RightSection
} from '../../components/layouts/SectionHeader';

import ApiActions from '../../action/ActionFactory';
import {
  parsePBIMeta,
  getPBIContextFilter,
  genPBICommand
} from '../../utils/helpers/powerbi';

import {
  FilterGroup,
  CountryFilter,
  CostcenterFilter
} from '../../components/filter';

// Update to default role when applying with country change
import { changeCurrentRole } from '../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../components/common/Profile/selector';
import { updateCurrentRole } from '../../components/common/Profile/utils';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../action/CommonActions';

import * as routes from '../../routes/const';
import { getInsightsCCAndCountry, getRestrictionFilter } from './selector';

const Container = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const NitroPanelExtended = styled(NitroPanel)`
  min-height: 80px;
  height: ${props => (props.height ? props.height : '800px')};
  min-width: 1342px;
  max-width: 1342px;

  @media (max-width: 1025px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }

  && iframe {
    height: 100%;
    border: none;
    html,
    body {
      background: transparent;
    }
  }
`;

export const SimpleHolder = styled.div`
  min-height: 80px;
  height: ${props => (props.height ? props.height : '800px')};
  width: ${props => (props.width ? props.width : '1200px')};
  max-width: 1200px;

  @media (max-width: 1025px) {
    width: 100%;
  }

  && iframe {
    max-width: 1200px;
    height: 100%;
    border: none;
    html,
    body {
      background: transparent;
    }
  }
`;

const cmdProfileDashboardTemplate = (reportId, visualId) => ({
  type: 'report',
  refId: reportId,
  pageName: 'ReportSection',
  commands: [
    {
      name: 'driver_dashboard',
      title: 'Driver Dashboard',
      visualId,
      action: {
        route: '/dashboard/driver/${COUNTRY_CODE}/${SRC_DRIVER_ID}'
      }
    },
    {
      name: 'vehicle_dashboard',
      title: 'Vehicle Dashboard',
      visualId,
      action: { route: '/dashboard/vehicle/${COUNTRY_CODE}/${LEASE_ID}' }
    }
  ]
});

const commandActions = {};
let buttonActions = {};
let routerContext = null;

const pbiEventHandlers = {
  buttonClicked: event => {
    if (buttonActions) {
      const btnId = event.detail.id;
      if (btnId && buttonActions[btnId]) {
        if (buttonActions[btnId].url)
          window.location = buttonActions[btnId].url;

        if (buttonActions[btnId].route)
          routerContext.push(buttonActions[btnId].route);
      }
    }

    pushGAAction('PBIReport', `BTN::${event.detail.id}`, '', event.detail);
    // console.log('pbi btn clicked', event.detail.id, event);
  },
  commandTriggered: event => {
    if (commandActions && commandActions[event.detail.command]) {
      pushGAAction(
        'PBIReport',
        `CMD::${event.detail.command}`,
        '',
        event.detail
      );
      commandActions[event.detail.command](event.detail.dataPoints);
    }
  },
  dataSelected: event => {
    // console.log('dataSelected', event);
    const { page, report, visual } = event.detail;
    pushGAAction('PBIReport', `DATA::${event.detail.id}`, '', event.detail);

    if (
      __ENV__ !== 'production' &&
      event &&
      (/detail report/gi.test(page.displayName) ||
        /tableEx/gi.test(visual.type))
    ) {
      const reportId = report.id;
      const visualId = visual.name;

      console.log(
        JSON.stringify(cmdProfileDashboardTemplate(reportId, visualId))
      );
    }
  }
};

class EmbedDisplay extends PureComponent {
  pbiReport = null;
  pbiFilters = null;
  contentMetaStr = null;

  componentDidUpdate(prevProps) {
    const { id, embedtype } = this.props.params;
    const { id: prevId } = prevProps;

    if (id !== prevId) {
      this.loadContent();
    }
  }

  componentDidMount() {
    this.loadContent();
    routerContext = this.context.router;
  }

  parsePBIMeta(strMeta) {
    if (!strMeta || strMeta === '') return;
    const { costcenter, restrictions } = this.props;
    let newMetadata = strMeta.replace(
      '@@COMPANY_CODE',
      JSON.stringify(costcenter.value)
    );
    restrictions.map(ea => {
      newMetadata = newMetadata.replace(
        `@@RESTYPE${ea.typeId}`,
        JSON.stringify(ea.values)
      );
    });

    return JSON.parse(newMetadata);
  }

  setSource = filters => {
    // update role here
    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });
    if (this.props.role.country !== country.value) {
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(routes.INSIGHTS);
        }
      );
    }
  };

  getContent(id) {
    return this.props.apiActions
      .get({
        resource: 'CONTENT',
        id
      })
      .then(data => data);
  }

  async loadContent() {
    const { id, embedtype = 'report' } = this.props.params;
    const contents = await this.getContent(id);
    this.contentMetaStr = contents[0].metadata;

    this.loadEmbed(embedtype, this.contentMetaStr);
  }

  loadEmbed = (embedtype = 'report', strPBIMeta) => {
    if (!this.pbiHolder) return;

    const { country, costcenter, restrictions, businessEntityName } = this.props;

    let embedMethod = '';
    switch (embedtype.toLowerCase()) {
      case 'report':
        embedMethod = 'getReportEmbedConfig';
        break;
      default:
      case 'dashboard':
        embedMethod = 'getDashboardEmbedConfig';
        break;
    }

    const pbiMeta = parsePBIMeta(strPBIMeta);
    buttonActions = pbiMeta.actions;

    this.loaderSpinner.style.display = 'block';
    this.pbiHolder.style.visibility = 'hidden';

    PowerBIApi[embedMethod](
      country.value,
      costcenter.value,
      pbiMeta.refId,
      businessEntityName === 'FleetPlus' ? 'FleetPlus' : 'FleetPartners'
    ).then(conf => {
      conf.filters = getPBIContextFilter(
        conf.company,
        restrictions,
        conf.userRestrictions
      );

      conf.pageName = pbiMeta.pageName;
      conf.settings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false
      };

      if (pbiMeta.commands && pbiMeta.commands.length > 0) {
        conf.settings.extensions = pbiMeta.commands.map(ea => {
          commandActions[ea.name] = dataPoints => {
            const { action } = ea;

            if (!action) throw new Error('action is not defined');

            if (!dataPoints || dataPoints.length === 0)
              throw new Error('datapoint not found');

            const sglData = [].concat(dataPoints[0].identity, dataPoints[0].values);
            const drvIdDataPoint = sglData.find(x =>
              /src_driver_id/gi.test(x.target.column)
            );

            const leaseIdDataPoint = sglData.find(x =>
              /(leaseId|lease_id)/gi.test(x.target.column)
            );

            if (!drvIdDataPoint && !leaseIdDataPoint)
              throw new Error('DriverID / LeaseID datapoint not found');

            if (action.route) {
              let leaseId = '';
              if (leaseIdDataPoint && leaseIdDataPoint.hasOwnProperty('equals')) leaseId = leaseIdDataPoint.equals;
              if (leaseIdDataPoint && leaseIdDataPoint.hasOwnProperty('value')) leaseId = leaseIdDataPoint.value;
              const transformedRoute = action.route
                .replace(
                  '${SRC_DRIVER_ID}',
                  drvIdDataPoint ? drvIdDataPoint.equals : ''
                )
                .replace(
                  '${LEASE_ID}',
                  leaseId
                )
                .replace(
                  '${COUNTRY_CODE}',
                  this.props.country.value.toLowerCase()
                );

              this.context.router.push(transformedRoute);
            } else if (action.url) {
              window.location = action.url;
            }
          };
          return genPBICommand(ea.name, ea.title, ea.visualId);
        });
      }

      window.powerbi.preload(conf);
      window.powerbi.reset(this.pbiHolder);

      const myholder = this.pbiHolder;
      const unloadEvents = [
        'buttonClicked',
        'dataSelected',
        'commandTriggered'
      ];
      unloadEvents.forEach(ea => {
        myholder.removeEventListener(ea, pbiEventHandlers[ea], true);
      });

      const pbireport = window.powerbi.embed(this.pbiHolder, conf);

      pbireport.on('buttonClicked', pbiEventHandlers.buttonClicked);

      pbireport.on('dataSelected', pbiEventHandlers.dataSelected);

      pbireport.on('commandTriggered', pbiEventHandlers.commandTriggered);

      pbireport.on('loaded', () => {
        if (this.loaderSpinner) {
          this.loaderSpinner.style.display = 'none';
        }

        this.pbiHolder.style.visibility = 'visible';
      });
    });
  };

  goBack = () => {
    const { router } = this.context;
    router.push(routes.INSIGHTS);
  };

  render() {
    const { country, costcenter, height, width, hideFilter } = this.props;
    let showBackNav = !/insights|summary/gi.test(this.props.location.pathname);
    if (this.props.hideBackNav) {
      showBackNav = false;
    }

    const HolderPanel = showBackNav ? NitroPanelExtended : SimpleHolder;

    const source = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter
      },
      {
        title: 'Cost Centre',
        value: costcenter.value,
        label: costcenter.label,
        component: CostcenterFilter
      }
    ];

    return (
      <Container>
        <Breakpoint name="desktop">
          {!hideFilter || showBackNav ? (
            <SectionHeader margin="30px 0">
              {showBackNav && (
                <LeftSection>
                  <NitroNavBar
                    label={this.props.title || 'back'}
                    action={this.goBack}
                    header
                  />
                </LeftSection>
              )}
              {hideFilter ? null : (
                <RightSection>
                  <FilterGroup
                    width="75%"
                    action={this.setSource}
                    title="Source"
                    icon="source"
                    filters={source}
                    align="right"
                  />
                </RightSection>
              )}
            </SectionHeader>
          ) : null}
        </Breakpoint>

        <HolderPanel height={height} width={width}>
          <div ref={node => (this.loaderSpinner = node)}>
            <NitroLoading thickness={3} />
          </div>
          <div
            ref={node => (this.pbiHolder = node)}
            style={{
              width: '100%',
              height: '100%',
              visibility: 'hidden'
            }}
          />
        </HolderPanel>
      </Container>
    );
  }
}

EmbedDisplay.contextTypes = {
  router: PropTypes.shape({})
};

EmbedDisplay.propTypes = {
  // True if there should be no visible back button
  hideBackNav: PropTypes.bool,

  // A css height value for the display
  height: PropTypes.string,

  // A css width value for the display
  width: PropTypes.string,

  // True if there should be no visible filter
  hideFilter: PropTypes.bool
};

EmbedDisplay.defaultProps = {
  hideBackNav: false,
  hideFilter: false,
  height: null,
  width: null
};

const mapStateToProps = state => {
  const { costcenter, country } = getInsightsCCAndCountry(state);
  const { restrictions } = getRestrictionFilter(state);
  const businessEntityName = state.auth.config.BusinessEntityName;

  return {
    country,
    costcenter,
    restrictions,
    businessEntityName,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state)
  };
};

const mapDispatchToProps = dispatch => ({
  apiActions: bindActionCreators(ApiActions, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmbedDisplay);



// WEBPACK FOOTER //
// ./src/features/powerbi/EmbedDisplay.js